import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { ITenderProtocol } from 'types/final-protocol'

export const tenderFinalProtocolApi = createApi({
  reducerPath: 'tenderFinalProtocol',
  tagTypes: ['TendersFinalProtocol', 'TenderProtocol'],
  baseQuery,
  endpoints: (builder) => ({
    // tenderFinalProtocol: builder.query<ITenderFinalProtocol, IdParams>({
    //   query: ({ id }) => {
    //     return {
    //       url: `/tenders/final-protocol/${id}`,
    //       method: 'get',
    //     }
    //   },
    //   providesTags: ['TendersFinalProtocol'],
    // }),

    // updateTenderFinalProtocol: builder.mutation<void, IdParams>({
    //   query: ({ id }) => ({
    //     url: `/tenders/final-protocol/${id}`,
    //     method: 'post',
    //   }),
    //   invalidatesTags: ['TendersFinalProtocol'],
    // }),

    tenderProtocol: builder.query<ITenderProtocol, IdParams>({
      query: ({ id }) => {
        return {
          url: `/tenders/${id}/protocol`,
          method: 'get',
        }
      },
      providesTags: ['TenderProtocol'],
    }),
    updateTenderProtocol: builder.mutation<void, Partial<ITenderProtocol>>({
      query: (body) => ({
        url: `/tenders/${body.tenderId}/protocol`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['TenderProtocol'],
    }),
  }),
})

export const { useTenderProtocolQuery, useUpdateTenderProtocolMutation } =
  tenderFinalProtocolApi
